import React from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";

import { CustomInput } from "src/component";
import { renderAlert, renderToastMsg } from "src/utils/functions";
import { createProfile } from "src/services/api";

const CreateProfile = ({
    editData,
    refetch,
    setModalOpen,
}) => {


    const initialValues = {
        name: "",
        email: "",
        password: "",
        password1: "",
    };

    const profileSchema = yup.object().shape({
        name: yup
            .string()
            .required("Staff name is required"),
        email: yup
            .string()
            .email("Please provide a valid email")
            .required("Please provide a valid email"),
        password: yup
            .string()
            .required("Password is required")
            .min(8, "Password must be 8 characters long")
            .matches(/[0-9]/, "Password requires a number")
            .matches(/[a-z]/, "Password requires a lowercase letter")
            .matches(/[A-Z]/, "Password requires an uppercase letter")
            .matches(/[^\w]/, "Password requires a symbol"),
        password1: yup
            .string()
            .required("Confirm Password is required")
            .oneOf([yup.ref("password"), null], "Passwords must match"),
    });

    const { mutate, isLoading } = useMutation(createProfile, {
        onSuccess: (res) => {
            if (res?.status === "success") {

                renderAlert({
                    title: "Success",
                    msg: res?.msg,
                    type: "success",
                }).then((result) => {

                    if (result) {
                        setModalOpen(false);
                    } else {
                        setModalOpen(false);
                    }
                });
                refetch();
            } else {
                renderToastMsg(res?.msg);
            }

        },
    });


    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={profileSchema}
                onSubmit={({ password1, ...values }) => {
                    mutate(values);
                }}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="px-[3rem] py-[2rem]">


                            <CustomInput
                                title="Name"
                                name="name"
                                placeholder="Enter Name"
                                onChange={handleChange}
                                value={values.name}
                                onBlur={handleBlur}
                                formType="fill"
                                isRequired={true}
                            />

                            <CustomInput
                                title="Email"
                                name="email"
                                placeholder="Enter email"
                                onChange={handleChange}
                                value={values.email}
                                onBlur={handleBlur}
                                formType="fill"
                                isRequired={true}
                                autocomplete="off"
                            />

                            <CustomInput
                                title="Password"
                                name="password"
                                passwordToggle
                                onChange={handleChange}
                                value={values.password}
                                onBlur={handleBlur}
                                formType="fill"
                                isRequired={true}
                                autocomplete="off"
                            />
                            <CustomInput
                                title="Confirm Password"
                                name="password1"
                                passwordToggle
                                onChange={handleChange}
                                value={values.password1}
                                onBlur={handleBlur}
                                formType="fill"
                                isRequired={true}
                            />


                        </div>

                        <div className="border-t border-t-gray">
                            <div className="flex justify-end px-[3rem] py-[2rem]">
                                <button
                                    disabled={isLoading}
                                    type="submit"
                                    className="btn-loader flex justify-center bg-lightPrimary items-center rounded-[5px]  text-defaultPrimary py-[2rem] px-[4rem] h-[3.5rem]"
                                >
                                    {editData ? "Update" : "Create"}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default CreateProfile;
